import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { cartSelectors, cartActions, cartUtils } from "../store/cartSlice"
import { useCloudinaryImage } from "../hooks/useCloudinaryImage"
import { formatCurrency } from "../utils/format"
import Layout from "../components/layout"
import Button, { ButtonVariants } from "../components/button"
import { getCartItem } from "../utils/getProduct"

function CartItem({ id, type, quantity }) {
  const dispatch = useDispatch()
  const product = getCartItem({ id, type })
  const productImage = useCloudinaryImage(product.image)

  const remove = () =>
    dispatch(
      cartActions.removeItem({
        id,
        type,
      })
    )

  return (
    <div className="flex flex-col md:flex-row md:items-center mb-4 border-gray-300 py-4">
      <img
        src={productImage}
        className="rounded w-32 h-32 mb-6 md:mb-0 md:w-24 md:h-24 md:mr-4"
        alt={product.name}
      />
      <div className="flex flex-col flex-1 mb-6 md:mb-0">
        <p className="text-heading-18 lg:text-heading-20">{product.name}</p>
        {type !== "membership" && (
          <React.Fragment>
            <p className="text-base lg:text-body-18 text-gray-700">
              Quantity: {quantity}
            </p>
            <p className="text-base lg:text-body-18 text-gray-700">
              Price per piece: {formatCurrency(product.price)}
            </p>
          </React.Fragment>
        )}
      </div>
      <p className="text-heading-18 text-right md:text-left mb-4 md:mb-0 md:mr-8">
        {formatCurrency(product.price * quantity)}
      </p>
      <Button onClick={remove}>Remove</Button>
    </div>
  )
}

export default function Cart() {
  const dispatch = useDispatch()
  const items = useSelector(cartSelectors.items)
  const totalCost = useSelector(cartUtils.totalCost(getCartItem))

  const clear = () => dispatch(cartActions.clear())

  return (
    <Layout>
      <section className="py-20 w-full bg-white">
        <div className="container content-container container-centered">
          <h1 className="text-heading-36 lg:text-heading-48 mb-8">Cart</h1>
          {items.length === 0 && (
            <p className="text-base lg:text-body-18 text-gray-900">
              You have no items in your cart.
            </p>
          )}
          {items.map(item => (
            <CartItem key={item.id} {...item} />
          ))}
          {items.length > 0 && (
            <React.Fragment>
              <div className="flex justify-end my-8">
                <p className="text-base lg:text-heading-18">
                  Total: {formatCurrency(totalCost)}
                </p>
              </div>
              <div className="flex justify-end">
                <Button
                  outlined
                  variant={ButtonVariants.CallToAction}
                  disabled={items.length === 0}
                  className="mr-4"
                  to="/checkout"
                >
                  Checkout
                </Button>
                <Button onClick={clear}>Clear Cart</Button>
              </div>
            </React.Fragment>
          )}
        </div>
      </section>
    </Layout>
  )
}
